import { selectRequestByType } from 'ducks/requests/selectors'
import { FETCH_CONVERSATION_COUNTS_FOR_CHANNEL } from 'ducks/searches/actionTypes'

export const selectSearchesRequestState = state =>
  selectRequestByType(state, FETCH_CONVERSATION_COUNTS_FOR_CHANNEL)
